import { render, staticRenderFns } from "./customerInfo.vue?vue&type=template&id=4c414ac8&scoped=true&"
import script from "./customerInfo.vue?vue&type=script&lang=js&"
export * from "./customerInfo.vue?vue&type=script&lang=js&"
import style0 from "./customerInfo.vue?vue&type=style&index=0&id=4c414ac8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c414ac8",
  null
  
)

export default component.exports